import React, { Component } from "react"
import ReactMarkdown from "react-markdown"

import { ContentfulClient } from "./../../settings"
import { animateScroll } from "react-scroll"


// Components
import "./style.css"
import MediumSpacer from "./../../components/MediumSpacer"
import BigSpacer from "./../../components/BigSpacer"
import LoadingBox from "./../../components/LoadingBox"

// Page template
class Page extends Component {
    constructor() {
        super()

        this.state = {
            page: null
        }
    }

    componentDidMount () {
        this.getPageContent(this.props.match.params.id)
    }

    componentDidUpdate (prevProps) {
        const prevId = prevProps.match.params.id
        const thisId = this.props.match.params.id

        if (prevId !== thisId && thisId) {
            animateScroll.scrollToTop({ duration: 300})
            this.getPageContent(thisId)
        }
    }

    getPageContent (pageId) {
        ContentfulClient.getEntry(pageId, {include: 4})
            .then(res => {
                this.setState({page: res.fields})
            })
            .catch(error => { console.error(error) })
    }

    render () {
        const { page } = this.state

        if (!page) return <LoadingBox text="Laster småhistorien..." />

        return (
            <div className="short-story">
                <MediumSpacer />

                <div className="container">
                    <h1 className="short-story__page-title">{ page.pageTitle }</h1>
                </div>

                { page.hasOwnProperty("featuredImage") && <div className="featured-image">
                    <div className="featured-image__inner">
                        <img src={page.featuredImage} alt="Uthevet bilde for småhistorien"/>
                    </div>
                </div>}

                <div className="container reading content-columns">
                    <ReactMarkdown source={page.content} />
                </div>

                <BigSpacer />
            </div>
        )
    }
}

export default Page



// WEBPACK FOOTER //
// ./src/containers/Page/index.js